export const addMonths = {
  methods: {
    addMonths(date, months) {
      const temp = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() !== temp) {
        date.setDate(0)
      }
      return date
    }
  }
};